import styled from 'styled-components';

export default styled.div`
  .textField-area-wrap {
    height: auto;
    textarea {
      padding-top: 10px;
    }
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .textField-area-line-wrap {
    .MuiOutlinedInput-root {
      border: 1px solid #ccc;
      /* border-top: none; */
    }
    .MuiInputLabel-root {
      padding-left: 8px;
      padding-right: 10px;
      background: #fff;
    }
  }
  .button-wrap {
    .Mui-disabled {
      color: #fff;
      box-shadow: 0 0 1px 0 rgb(0 0 0 / 31%), 0 2px 2px -2px rgb(0 0 0 / 25%);
      background-color: #1565c0;
    }
  }
`;
